import { useState,useEffect,useRef } from "react";
import axios from 'axios';
import io from 'socket.io-client'
import style from './popup.module.css';
import { useAuthLocalStorage } from '../../modules/useLocalStore';
import close from '../../img/close.png';
import coin from '../../img/coinmax.png';
import rub from '../../img/rub.png';
import present1 from '../../img/prisents/prisent1.png';
import present2 from '../../img/prisents/prisent2.png';
import present3 from '../../img/prisents/prisent3.png';
import present4 from '../../img/prisents/prisent4.png';
import present5 from '../../img/prisents/prisent5.png';
import present6 from '../../img/prisents/prisent6.png';
import present7 from '../../img/prisents/prisent7.png';
import present8 from '../../img/prisents/prisent8.png';
import present9 from '../../img/prisents/prisent9.png';
import present10 from '../../img/prisents/prisent10.png';
import present11 from '../../img/prisents/prisent11.png';
import present12 from '../../img/prisents/prisent12.png';
import present13 from '../../img/prisents/prisent13.png';
import present14 from '../../img/prisents/prisent14.png';
import present15 from '../../img/prisents/prisent15.png';
import submit from '../../img/submit.png'
import error from '../../img/error.png'
import gift from '../../img/gift_send.png'
import smile from '../../img/smile.png'
import EmojiPicker from 'emoji-picker-react';
import likeimg from '../../img/like_min.svg'
import nopic from '../../img/no_photo_neutral.svg'

function Popup({myProfile , setMyProfile, page , setPage, stage , setStage, setAllChats, allChats, setUserMessage, message, setLike, like, setMutual,mutual,socketRef}){

    const { getToken, removeToken } = useAuthLocalStorage();
    const token = getToken();
    const [conins, setCoints] = useState(10);
    const [moneys, setMoneys] = useState(750);
    const [selectvip, setSelectvip] = useState(0);
    const [selectpresent, setSelectPresents] = useState(0);
    const [inputMess, setInputMess] = useState('');
    const [emojiblock, setEmojiBlock] = useState(false);


    const selections = [
        {id: 0, monets: 10, days: 7, text: 'VIP на 7 дней'}
        /*{id: 1, monets: 30, days: 30, text: 'VIP на 30 дней'},
        {id: 2, monets: 80, days: 90, text: 'VIP на 90 дней'}*/
    ];
    const prisents = [
        {id: 0, price: 35, img: present1},
        {id: 1, price: 30, img: present2},
        {id: 2, price: 30, img: present3},
        {id: 3, price: 25, img: present4},
        {id: 4, price: 25, img: present5},
        {id: 5, price: 20, img: present6},
        {id: 6, price: 20, img: present7},
        {id: 7, price: 15, img: present8},
        {id: 8, price: 15, img: present9},
        {id: 9, price: 10, img: present10},
        {id: 10, price: 10, img: present11},
        {id: 11, price: 5, img: present12},
        {id: 12, price: 5, img: present13},
        {id: 13, price: 5, img: present14},
        {id: 14, price: 5, img: present15},

    ];
    const PopupOpen = (ind) => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: ind
            }
        }));
    };
    const formatDateFromUnixTime = (unixTime) => {
        const date = new Date(unixTime * 1000);
        const formattedDate = `${(date.getDate() < 10 ? '0' : '') + date.getDate()}.${(date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1)}.${date.getFullYear()} ${(date.getHours() < 10 ? '0' : '') + date.getHours()}:${(date.getMinutes() < 10 ? '0' : '') + date.getMinutes()}`;
    
        return formattedDate;
      }
    const handleLogout = () => {
        setUserMessage([]);
        
        setAllChats([]);
        setLike([]);
        setMutual([]);
        removeToken();
        setStage(0);
        setPage(1);
        removeProfile();
        exitPopup();
        window.location.reload();

    };
    const changeMoney = (e) => {
        setCoints(e.target.value);
        
    }
    useEffect(() => {
        var mon = conins * 45;
        setMoneys(mon);
        
    }, [conins]);
    const removeProfile = () =>{
        setMyProfile({
            info: {like: 0, likeall: 0, notice: false, menuopen: false, likeopen: false, profile: null, popup: null}
        });
    }
    const exitPopup = () => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                popup: null
            }
        }));
    }
    const SendPresent = () => {
        if(myProfile.money < prisents[selectpresent].price)
        {
            var coins = prisents[selectpresent].price - myProfile.money;
            //setCoints(coins);
            PopupOpen(2);
            return false;
        }
        function convertImageToBlob(imageSrc) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = imageSrc;
        
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    
                    // Получить данные в формате Blob
                    canvas.toBlob((blob) => {
                        if (blob) {
                            resolve(blob);
                        } else {
                            reject(new Error('Canvas is empty'));
                        }
                    }, 'image/png'); // Укажите нужный формат
                };
        
                img.onerror = (error) => {
                    reject(error);
                };
            });
        }
        if(token !== null)
            {
                
                convertImageToBlob(prisents[selectpresent].img)
                .then(blob => {
                    const formData = new FormData();
                    formData.append('image', blob);
                    formData.append('price', prisents[selectpresent].price);
                    formData.append('id', myProfile.sendselect);
                    const config = {
                        headers: {
                            Authorization: "Bearer " + token,
                            'Content-Type': 'multipart/form-data'
                        }
                    };
                    
                    axios.post(`https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/sendPresent`, formData,config)
                    .then(response => {
                        if(response.data.insertid)
                        {
                            
                            const insertid = response.data.insertid;
                            const roomid = response.data.id_room;

                           
                            
                           
                            PopupOpen(10);
                            setMyProfile(prevState => ({
                                ...prevState,
                                money: response.data.money
                            }));
                            
                        }
                        else
                        {
                            if(response.data.nomoney)
                            {
                                var coins = prisents[selectpresent].price - response.data.money;
                                setMyProfile(prevState => ({
                                    ...prevState,
                                    money: response.data.money
                                }));
                                setCoints(coins);
                                PopupOpen(2);
                                return false;
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error uploading image:', error);
                    });
                })
                .catch(error => {
                    console.error('Error converting image to Blob:', error);
                });
              
               
            }
        
        

    }
    const onEmojiClick = (event, emojiObject) => {
        setInputMess((prevMessages) => {
            return prevMessages + event.emoji;
        });
        setEmojiBlock(false);
      };
    const sendGift = () => {
        
        PopupOpen(9);
    };
    const returnpay = () => {
        
        window.location.href = 'https://im-gpt.ru/pay.php?email='+myProfile.login;
    };
    
    const sendMessage = () => {
        if(inputMess === null || inputMess === '') return false;
        if(myProfile.money <= 0)
        {
            PopupOpen(8);
            setInputMess('');
            return false;
        } 
        if(!myProfile.sendselect)
        {
            console.log(myProfile.sendselect);
            setInputMess('');
            return false;
        }
        if(token !== null)
        {
                
            const body = {
                text: inputMess,
                id: myProfile.sendselect
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + token
                }
            };
            
            axios.post(`https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/sendMess`, body,config)
            .then(response => {
                if(response.data.insertid)
                {
                    
                    const insertid = response.data.insertid;
                    const roomid = response.data.id_room;
                    setMyProfile(prevState => ({
                        ...prevState,
                        money: response.data.money
                    }));
                    setInputMess('');
                    PopupOpen(16);
                }
                else
                {
                    if(response.data.err)
                    {
                    
                        setMyProfile(prevState => ({
                            ...prevState,
                            money: response.data.money
                        }));
                        setInputMess('');
                        PopupOpen(5);
                        
                        return false;
                    }
                }
            })
            .catch(error => {
                console.error('Error uploading image:', error);
            });
                
               
        }
       
        
    };
    const payonVip = () => {
        if(myProfile.money < selections[selectvip].monets)
        {
            PopupOpen(4);
            setCoints(selections[selectvip].monets);
            return false;
        }
        if(token !== null)
        {
            const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getVip`;
            const config = {
                headers: {
                    Authorization: "Bearer " + token
                }
            };
            const body = {
                days : selections[selectvip].days,
                price: selections[selectvip].monets
            };
            axios.post(url,body, config)
                .then(response => {
                    
                    if(response.data.nomoney === true)
                    {
                        
                        PopupOpen(4);
                        setCoints(selections[selectvip].monets);
                        setMyProfile(prevState => ({
                            ...prevState,
                            money: response.data.money
                        }));
                        return false;
                    }
                    else
                    {
                        setMyProfile(prevState => ({
                            ...prevState,
                            money: response.data.money,
                            vip: response.data.vip
                        }));
                        PopupOpen(14);
                    }
                })
                    .catch(error => {
                        console.log(error);
                    
                        
                });
        }

        
    };
    const clickprofile = (id) => {
        setMyProfile(prevState => ({
            ...prevState,
            info: {
                ...prevState.info,
                profile: id
            }
        }));
        setPage(5);
        exitPopup();
    };
    const likeprofile = (id) => {
        if(token !== null)
        {
                
            const body = {
                id: id
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + token
                }
            };
            
            axios.post(`https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/liketo`, body,config)
            .then(response => {
                if(response.data.profile && response.data.profile === true)
                {
                    const url = `https://winxy.ru:${process.env.REACT_APP_PORT_SERVER}/api/getLike`;
                    const config = {
                        headers: {
                            Authorization: "Bearer " + token
                        }
                    };
                    axios.post(url,{}, config)
                        .then(response => {
                            
                            if(response.data.like === true)
                            {
                                
                                setLike(response.data.date);
                            }
                            else
                            {
                                setLike([]);
                            }
                        })
                            .catch(error => {
                                console.log(error);
                            
                                
                        });
                    
                }
            })
            .catch(error => {
                console.error('Error uploading image:', error);
            });
                
                
        }
    };
    let content = null;
    
    switch (myProfile.info.popup) {    
        case 1:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popmin}>
                        <div className={style.flextop}>
                            <h3>Выйти из аккаунта?</h3>
                            <h4>😔</h4>
                        </div>
                        <p>Ты покидаешь аккаунт, подтверди свои дейстия</p>
                        <div className={style.flexbtn}>
                            <button className={style.btnone} onClick={exitPopup}>Остаться</button>
                            <button className={style.btntwo} onClick={handleLogout}>Выйти</button>
                        </div>
                    </div>
                </div>
            );
            break;
         case 2:

            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.brdh3}>Сумма к оплате</h3>
                        <p className={style.labelp}>Кол-во монет</p>
                        <div className={style.flexinput}>
                            <div className={style.flexleft}>
                                <input type='number' className={style.inputmoneta} min='1' max='999' step='1' value={conins} onChange={changeMoney} readOnly/>
                                <p>монет</p>
                            </div>
                            <img src={coin} alt='' />
                        </div>
                        <p className={style.labelp}>Сумма к оплате</p>
                        <div className={style.flexinput}>
                            <div className={style.flexleft}>
                                <input className={style.inputmoneta} value={moneys} readOnly/>
                                <p>рублей</p>
                            </div>
                            <img src={rub} alt='' />
                        </div>
                        <button className={style.btngred} onClick={() => returnpay()}>Пополнить</button>
                        <p className={style.balance}>Ваш баланс: {myProfile.money} монет</p>
                    </div>
                </div>
            );
            break;
        case 3:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.viph3}>Активируй VIP 🫶</h3>
                        <p className={style.vipp}>Выбери подходящий тариф</p>
                        <p className={style.balancevip}>Баланс: {myProfile.money} монет</p>
                        <div>
                            {selections.map (d => 
                                <div className={style.flexvip + ' ' + ((d.id === selectvip) ? style.active : '')} key={d.id}>
                                    <div className={style.leftvip}>
                                        <img src={coin} alt=''/>
                                        <p>{d.monets} монет</p>
                                    </div>
                                    <div className={style.selectvips} onClick={() => setSelectvip(d.id)}>
                                        {d.days} дней
                                    </div>
                                </div>
                            )}
                        </div>
                        <button className={style.btnnext} onClick={() => {
                            payonVip();
                            
                        }}>Получить VIP</button>
                        
                    </div>
                </div>
             );   
            break;
        case 4:
                
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.brdh3}>{selections[selectvip].text}</h3>
                        <p className={style.labelp}>Введи кол-во монет</p>
                        <div className={style.flexinput}>
                            <div className={style.flexleft}>
                                <input type='number' className={style.inputmoneta} min='1' max='999' step='1' value={conins} onChange={changeMoney} readOnly/>
                                <p>монет</p>
                            </div>
                            <img src={coin} alt='' />
                        </div>
                        <p className={style.labelp}>Сумма к оплате</p>
                        <div className={style.flexinput}>
                            <div className={style.flexleft}>
                                <input className={style.inputmoneta} value={moneys} readOnly/>
                                <p>рублей</p>
                            </div>
                            <img src={rub} alt='' />
                        </div>
                        <button className={style.btngred} onClick={() => returnpay()}>Пополнить</button>
                        <p className={style.balance}>Ваш баланс: {myProfile.money} монет</p>
                    </div>
                </div>
            );
            break;
        case 5:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.viph3}>Только VIP аккаунты ✌️ <br/> могут писать первыми.</h3>
                        <div className={style.flexogran}>
                            <p>Входит в vip</p> 
                            <span>🫶</span>
                        </div>
                        <div className={style.plusvip}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Писать первым</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Отправлять фотографии</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Просмотр номеров телефонов и социальных сетей</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Возможность отправить номер телефона и социальные сети</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Увеличенный лимит сообщений</p>
                            </div>
                        </div>
                        <button className={style.btnnext} onClick={() => returnpay()}>Получить VIP</button>
                        
                    </div>
                </div>
                );   
            break;
        case 6:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.viph3}>Только VIP аккаунты ✌️ <br/> могут отправлять и просматривать личную информацию.</h3>
                        <div className={style.flexogran}>
                            <p>Входит в vip</p> 
                            <span>🫶</span>
                        </div>
                        <div className={style.plusvip}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Писать первым</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Отправлять фотографии</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Просмотр номеров телефонов и социальных сетей</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Возможность отправить номер телефона и социальные сети</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Увеличенный лимит сообщений</p>
                            </div>
                        </div>
                        <button className={style.btnnext} onClick={() => returnpay()}>Получить VIP</button>
                        
                    </div>
                </div>
                );   
            break;
        case 7:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.viph3}>Только VIP аккаунты ✌️ <br/> могут смотреть симпатии.</h3>
                        <div className={style.flexogran}>
                            <p>Входит в vip</p> 
                            <span>🫶</span>
                        </div>
                        <div className={style.plusvip}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Писать первым</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Общение без ограничений</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Просмотр кто тебя лайкнул</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Смотри взаимные симпатия</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Возвращаться к предыдущей анкете</p>
                            </div>
                        </div>
                        <button className={style.btnnext} onClick={() => {
                            PopupOpen(3);
                        }}>Получить VIP</button>
                        
                    </div>
                </div>
                );   
            break;
        case 8:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.viph3}>Доступ ограничен ⛔️ <br/></h3>
                        <div className={style.plusvip + ' ' + style.newmagin}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Вы потратили лимит сообщений на сегодняшний день</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Чтобы продолжить общение пополните баланс на 10 монет.</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Или подождите пока лимит обновится на следующий день</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Сразу после пополнения Ваш аккаунт сможет продолжить общение.</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Специально для Вас мы подбираем лучшие пары.</p>
                            </div>
                        </div>
                        <button className={style.btnnext} onClick={() => {
                            PopupOpen(2);
                        }}>Пополнить баланс</button>
                        
                    </div>
                </div>
                );   
            break;
        case 9:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.presenth3}>Сделать комплемент</h3>
                        <p className={style.presentp}>Выбери подходящий:</p>
                        <div className={style.scroll}>
                            {prisents.map(pr => 
    
                                <div className={style.present + ' ' + (pr.id === selectpresent ? style.selections : '')} key={pr.id} onClick={() => setSelectPresents(pr.id)}>
                                    <img className={style.pris} src={pr.img} alt=''/>
                                    <div className={style.pricepresent}>
                                        <img src={coin} alt=''/>
                                        <p>{pr.price}</p>
                                    </div>
                                </div>
                                
                            )}
                            
                        </div>
                        <p className={style.balancepresent}>Ваш баланс: {myProfile.money} монет</p>
                        <button className={style.btnnext} onClick={() => {
                            SendPresent()
                        }}>Отправить комплимент</button>
                        
                    </div>
                </div>
                );   
            break;
        case 10:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popmin}>
                        <div className={style.flextop}>
                            <h3>Комплемент отправлен</h3>
                            <h4>💌</h4>
                        </div>
                        <p>Ты настоящий джентельмен!</p>
                        <div className={style.flexbtn}>
                            <button className={style.btnone + ' ' + style.marg0} onClick={exitPopup}>Закрыть</button>
                        </div>
                    </div>
                </div>
                );   
            break;
        case 11:
            //Отправка сообщения
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.paddmessage}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.messageh3}>Новое сообщение</h3>
                        <textarea placeholder="Напиши сообщение..." className={style.textareapop} value={inputMess} onChange={e => setInputMess(e.target.value)} />
                        {emojiblock ?
                            <div className={style.smileadd}>
                                <EmojiPicker onEmojiClick={onEmojiClick} height={300} width='100%' searchDisabled='false'/>
                            </div>
                            :
                            null
                        }
                        <div className={style.flexpopmess}>
                            <img src={gift} alt="" className={style.giftsend} onClick={sendGift}/>
                            <img src={smile} alt ="" className={style.smilesend} onClick={
                                ()=> (
                                setEmojiBlock(prevState => (
                                    !prevState))
                            )
                            }/>
                            <button className={style.btnsendmesspop} onClick={() => sendMessage()}>Отправить</button>
                        </div>
                    </div>
                </div>
                );   
            break;
        case 12:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.likethis}>
                        <div className={style.likeflex}>
                            <h3>Мои лайки</h3>
                            <img src={close} onClick={exitPopup} alt=''/>
                        </div>
                        <div className={style.scrolllike}>
                        {like.map(l =>
                            
                            <div className={style.likeclick} key={l.id}>
                                <div className={style.leftflex} onClick={() => clickprofile(l.id_of)}>
                                    {l.avatar ? <img src={`https://winxy.ru/static_img.php?id=${l.avatar}`} alt=''/> : <img src={nopic} alt=''/> }
                                    <div className={style.dateinfo}>
                                        <h3>{l.name}</h3>
                                        <p>поставил(а) Вам лайк</p>
                                        <span>{formatDateFromUnixTime(l.unixtime)}</span>
                                    </div>
                                </div>
                                <img src={likeimg} className={style.likeyes} alt='' onClick={() => likeprofile(l.id_of)}/>
                            </div>
                        )}
                        </div>
                        
                        
                        
                    </div>
                </div>
                );  
            break;
        case 13:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.likethis}>
                        <div className={style.likeflex}>
                            <h3>Взаимные лайки</h3>
                            <img src={close} onClick={exitPopup} alt=''/>
                        </div>
                        <div className={style.scrolllike}>
                        {mutual.map(l =>
                            
                            <div className={style.likeclick} key={l.id} onClick={() => clickprofile(l.id_of)}>
                                <div className={style.leftflex}>
                                    {l.avatar ? <img src={`https://winxy.ru/static_img.php?id=${l.avatar}`} alt=''/> : <img src={nopic} alt=''/> }
                                    <div className={style.dateinfo}>
                                        <h3>{l.name}</h3>
                                        <p>Взаимная симпатия</p>
                                    </div>
                                </div>
                            </div>
                        )}
                        </div>
                        
                        
                        
                    </div>
                </div>
                );  
            break;
        case 14:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.bigtextpop}>Вы успешно приобрели VIP!</h3>
                        <img className={style.subimg} src={submit} alt=''/>
                        
                    </div>
                </div>
                );   
            break;
        case 15:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.bigtextpop}>Логин или пароль неверный!</h3>
                        <p className={style.mintextpop}>Проверьте правильность написания.</p>
                        <img className={style.subimg} src={error} alt=''/>
                        
                    </div>
                </div>
                );  
            break;
        case 16:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.bigtextpop}>Сообщение отправлено!</h3>
                        <img className={style.subimg} src={submit} alt=''/>
                        
                    </div>
                </div>
                );   
            break;
        case 17:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.bigtextpop}>Баланс успешно пополнен!</h3>
                        <img className={style.subimg} src={submit} alt=''/>
                        
                    </div>
                </div>
                );   
            break;
        case 18:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.bigtextpop}>Оплата прошла успешно!</h3>
                        <img className={style.subimg} src={submit} alt=''/>
                        
                    </div>
                </div>
                );   
            break;
        case 19:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.bigtextpop}>Успешный вход!</h3>
                        <img className={style.subimg} src={submit} alt=''/>
                        
                    </div>
                </div>
                );   
            break;
        case 20:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.bigtextpop}>Пароль изменен!</h3>
                        <img className={style.subimg} src={submit} alt=''/>
                        
                    </div>
                </div>
                );   
            break;
        case 21:
         content = (
            <div className={style.bgpopup}>
                <div className={style.popandclose + ' ' + style.padd15}>
                    <h3 className={style.bigtextpop}>Загрузка приложения...</h3>
                    <span className={style.loader}></span>
                    
                </div>
            </div>
            );   
            break;
        case 22:
                content = (
                    <div className={style.bgpopup}>
                        <div className={style.popandclose + ' ' + style.padd15}>
                            <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                            <h3 className={style.bigtextpop}>Изменения сохранены!</h3>
                            <img className={style.subimg} src={submit} alt=''/>
                            
                        </div>
                    </div>
                    );   
                break;
        case 23:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.viph3}>Часовой лимит лайков <br/> истек. ✌️</h3>
                        <div className={style.plusvip + ' ' + style.newmagin}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>У вас закончились лайки, лимит лайков обновляется каждый час.</p>
                            </div>
                             <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Каждые час Вам дается 5 лайков.</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Пока обновляется лимит Вы можете перейти к сообщениям.</p>
                            </div>
                        </div>
                        <button className={style.btnnext} onClick={() => {
                            setPage(2);
                            exitPopup();
                        }}>Перейти в сообщения</button>
                        
                    </div>
                </div>
                );   
            break;
        case 24:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.viph3}>Предупреждение о лимите ✌️</h3>
                        <div className={style.plusvip + ' ' + style.newmagin}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Будьте избирательны в выставлении лайков, так как их количество ограничено.</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>У вас осталось 4 лайка на данный час.</p>
                            </div>
                             <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Каждые час Вам дается 5 лайков.</p>
                            </div>
                        </div>
                        <button className={style.btnnext} onClick={() => {
                            exitPopup();
                        }}>Прочитано</button>
                        
                    </div>
                </div>
                );   
            break;
        case 25:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <h3 className={style.viph3}>Фотография не прошла проверку 😔</h3>
                        <div className={style.plusvip + ' ' + style.newmagin}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Попробуйте еще раз, хорошая фотография залог успеха ☺️</p>
                            </div>
                        </div>
                        <button className={style.btnnext} onClick={() => {
                            exitPopup();
                        }}>Закрыть</button>
                        
                    </div>
                </div>
                );   
            break;
        case 26:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <h3 className={style.viph3}>Фотография успешно прошла проверку 🫡</h3>
                        <div className={style.plusvip + ' ' + style.newmagin}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Теперь Вы можете находить новые знакомства 💋</p>
                            </div>
                            
                        </div>
                        <button className={style.btnnext} onClick={() => {
                            exitPopup();
                        }}>Закрыть</button>
                        
                    </div>
                </div>
                );   
            break;
         case 27:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.bigtextpop}>У Вас уже есть зарегистрированный аккаунт!</h3>
                        <p className={style.mintextpop}>По правилам сервиса разрешено иметь только один аккаунт.</p>
                        <img className={style.subimg} src={error} alt=''/>
                        
                    </div>
                </div>
                );  
            break;
        case 28:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <h3 className={style.viph3}>Фотография успешно прошла проверку 🫡</h3>
                        <div className={style.plusvip + ' ' + style.newmagin}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>В связи с маленьким количеством мужских анкет - девушки тут пишут первые 😘</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Теперь Вы можете находить новые знакомства 💋</p>
                            </div>
                            
                        </div>
                        <button className={style.btnnext} onClick={() => {
                            exitPopup();
                        }}>Закрыть</button>
                        
                    </div>
                </div>
                );   
            break;
         case 29:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.viph3}>Получить VIP ✌️</h3>
                        <div className={style.flexogran}>
                            <p>Входит в vip</p> 
                            <span>🫶</span>
                        </div>
                        <div className={style.plusvip}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Писать первым</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Отправлять фотографии</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Просмотр номеров телефонов и социальных сетей</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Возможность отправить номер телефона и социальные сети</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Увеличенный лимит сообщений</p>
                            </div>
                        </div>
                        <button className={style.btnnext} onClick={() => returnpay()}>Получить VIP</button>
                        
                    </div>
                </div>
                );   
            break;
        case 30:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.viph3}>Только VIP аккаунты ✌️ <br/> могут отправлять фотографии.</h3>
                        <div className={style.flexogran}>
                            <p>Входит в vip</p> 
                            <span>🫶</span>
                        </div>
                        <div className={style.plusvip}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Писать первым</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Отправлять фотографии</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Просмотр номеров телефонов и социальных сетей</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Возможность отправить номер телефона и социальные сети</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Увеличенный лимит сообщений</p>
                            </div>
                        </div>
                        <button className={style.btnnext} onClick={() => returnpay()}>Получить VIP</button>
                        
                    </div>
                </div>
                );   
            break;
        case 31:
            content = (
                <div className={style.bgpopup}>
                    <div className={style.popandclose + ' ' + style.padd15}>
                        <img src={close} className={style.close} onClick={exitPopup} alt=''/>
                        <h3 className={style.viph3}>Для продолжения общения необходим VIP ✌️</h3>
                        <div className={style.flexogran}>
                            <p>Входит в vip</p> 
                            <span>🫶</span>
                        </div>
                        <div className={style.plusvip}>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Писать первым</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Отправлять фотографии</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Просмотр номеров телефонов и социальных сетей</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Возможность отправить номер телефона и социальные сети</p>
                            </div>
                            <div className={style.flexvips}>
                                <div className={style.orange}></div>
                                <p>Увеличенный лимит сообщений</p>
                            </div>
                        </div>
                        <button className={style.btnnext} onClick={() => returnpay()}>Получить VIP</button>
                        
                    </div>
                </div>
                );   
            break;
        default:
            
            content = null;
    }
    
    return content;
}

export default Popup;